import { FC } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { NextCheckpointCardModel } from 'src/apps/Path/buildNextCheckpointCardModel';
import { PathProgressTrack } from 'src/apps/Path/PathProgressTrack';
import * as S from './styles';

const msgs = defineMessages({
  sessionsToNextCheckpoint: {
    id: 'eos_learn_sessions_to_next_checkpoint',
    defaultMessage: '{count, plural, one {# session} other {# sessions}} to your next checkpoint',
  },
  checkpointReached: {
    id: 'eos_learn_next_checkpoint_reached',
    defaultMessage: 'Your next checkpoint is ready',
  },
  subtitle: {
    id: 'eos_learn_next_checkpoint_subtitle',
    defaultMessage: 'Keep going to unlock the next section of your path',
  },
});

export type CheckpointProgressCardProps = {
  model: NextCheckpointCardModel;
};

/**
 * End-of-session variant of the Home Path status card. Shows sessions remaining
 * to the next checkpoint and the shared Path progress track.
 */
export const CheckpointProgressCard: FC<CheckpointProgressCardProps> = ({ model }) => {
  const intl = useIntl();

  const { lessonsRemaining, totalSessions, progressRatio, nextCheckpoint } = model;

  const title =
    lessonsRemaining > 0
      ? intl.formatMessage(msgs.sessionsToNextCheckpoint, { count: lessonsRemaining })
      : intl.formatMessage(msgs.checkpointReached);

  return (
    <S.Card data-testid="eos-checkpoint-progress-card">
      <S.Title>{title}</S.Title>

      <PathProgressTrack
        size="compact"
        progressRatio={progressRatio}
        totalSessions={totalSessions}
        checkpointIcon={nextCheckpoint.icon}
        trackTestId="eos-checkpoint-track"
        fillTestId="eos-checkpoint-track-fill"
        dotsTestId="eos-checkpoint-dots"
        hereMarkerTestId="eos-checkpoint-here-marker"
      />

      <S.Subtitle>{intl.formatMessage(msgs.subtitle)}</S.Subtitle>
    </S.Card>
  );
};
